// removed by extract-text-webpack-plugin
module.exports = {"applicationFrameContainer":"_3CgR-bvDBXpdzp2oW4s-gg","loadingIndicator":"_1_JKvTdXxtoqn0KP7IdfuS"};


//////////////////
// WEBPACK FOOTER
// ./src/DomainApplicationView/DomainApplicationFrame.css
// module id = 199
// module chunks = 0